var RepeaterArrayDataAdapter = require("enyo-ui/RepeaterArrayDataAdapter"),
    kind                     = require("enyo/kind");

require("enyo-ui");

/**
 * [PageThumbnailCarouselDataAdapter]{@link app.MediaPlayer.Tech.ImageReader.PageThumbnailCarouselDataAdapter}
 * is designed to let
 * [PageThumbnailCarousel]{@link app.MediaPlayer.Tech.ImageReader.PageThumbnailCarousel}
 * use an Array as data source.
 *
 * This is a naive implementation that simply replaces all children when data
 * changes. As such, it probably does not scale very well for large arrays or
 * complicated child components.
 *
 * @class   app.MediaPlayer.Tech.ImageReader.PageThumbnailCarouselDataAdapter
 * @extends enyo-ui.RepeaterArrayDataAdapter
 * @public
 */
module.exports = kind(/** @lends app.MediaPlayer.Tech.ImageReader.PageThumbnailCarouselDataAdapter */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.Tech.ImageReader.PageThumbnailCarouselDataAdapter",

    /**
     * @private
     */
    kind: RepeaterArrayDataAdapter,

    /**
     * Super naive implementation, simply updates length and replaces all
     * children.
     *
     * @param {Array}  previous  The previous array
     * @memberof app.MediaPlayer.Tech.ImageReader.PageThumbnailCarouselDataAdapter
     * @private
     */
    dataChanged: function() {
        var repeater           = this.repeater,
            data               = repeater.data || [],
            averagePageRatio,
            placeholderOptions = repeater.placeholderOptions || {},
            arranger           = repeater.arranger || {},
            layoutPlaceholder  = arranger.layoutPlaceholder;

        // First change properties derived from data
        repeater.set("length", data.length);

        // Then change UI
        repeater.destroyPlaceholders();
        repeater.destroyChildren();

        if (repeater.length && repeater.hasNode()) {

            // Calculate average page ratio
            averagePageRatio = data.reduce(function(sum, page) {
                sum += parseInt(page.width, 10) / parseInt(page.height, 10);

                return sum;
            }, 0) / data.length;

            // Set average page ratio as placeholder ratio
            placeholderOptions.ratio    = averagePageRatio;
            repeater.placeholderOptions = placeholderOptions;

            // Update ratio of layoutPlaceholder if needed
            if (layoutPlaceholder) {
                layoutPlaceholder.ratio = averagePageRatio;
            }

            repeater.reflow(); // Automatically destroys all placeholders and children
            repeater.draw();
        }
    }

});
